module.exports = __webpack_public_path__ + "img/7.5a0af52c.png";